<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <PC-Table
          name="Tests"
          :headers="headers"
          :items="tests"
          @edit="edit"
          @remove="remove"
        />
        <PC-Dialog
          type="Edit Test"
          :showDialog="showDialog"
          :fields="fields"
          @close="close"
          @save="save"
        >
          <template v-slot:button><div></div></template>
        </PC-Dialog>
      </v-flex>
    </v-layout>
    <AdView id="165" />
    <PCModal />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import firebase from "@/firebase";
import AdView from "@/components/AdView";
import PCDialog from "@/components/PCDialog";
import PCModal from "@/components/PCModal";
import PCTable from "@/components/PCTable";

const initFields = [
  {
    name: "Borate",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "CH",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "CYA",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "FC",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "pH",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "Salt",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
  {
    name: "TA",
    type: "text",
    value: "",
    classes: ["pa-2", "xs12", "md6"],
  },
];

export default {
  components: { AdView, PCDialog, PCModal, PCTable },
  data() {
    return {
      editId: 1,
      fields: [],
      headers: [
        { text: "Timestamp", align: "left", value: "timestamp" },
        { text: "Pool", align: "left", value: "pool" },
        { text: "Borate", align: "left", value: "borate" },
        { text: "CH", align: "left", value: "ch" },
        { text: "CYA", align: "left", value: "cya" },
        { text: "FC", align: "left", value: "fc" },
        { text: "pH", align: "left", value: "ph" },
        { text: "Salt", align: "left", value: "salt" },
        { text: "TA", align: "left", value: "ta" },
        { text: "Actions", align: "left", value: "actions" },
      ],
      tests: [],
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      settings: "settings/getSettings",
    }),
    ...mapState({
      customFields: "fields",
    }),
    testsRef() {
      return firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("tests");
    },
  },
  methods: {
    ...mapActions({
      initFields: "fields/initFields",
      initSettings: "settings/initSettings",
    }),
    close() {
      this.showDialog = false;
    },
    async edit(id) {
      this.editID = id;
      const test = await this.testsRef.doc(id).get();
      const data = test.data();
      this.fields = [...initFields.map((x) => ({ ...x }))];
      this.fields[0].value = data.borate;
      this.fields[1].value = data.ch;
      this.fields[2].value = data.cya;
      this.fields[3].value = data.fc;
      this.fields[4].value = data.ph;
      this.fields[5].value = data.salt;
      this.fields[6].value = data.ta;

      if (data.poolID) {
        console.log("got a pool");
        for (let i = 0; i < this.settings.pools.length; i++) {
          const pool = this.settings.pools[i];
          if (pool.id === data.poolID) {
            const testSetup = pool.testSetup || this.settings.defaultTestSetup;
            if (testSetup) {
              console.log("have a test setup");
              testSetup.forEach((item) => {
                if (item.id.startsWith("custom_")) {
                  const id = item.id.substring(7);
                  if (item.active || id in data.customFieldValues) {
                    const fieldInfo = this.customFields.find(
                      (x) => x.id === id
                    );

                    this.fields.push({
                      name:
                        typeof fieldInfo === "undefined"
                          ? "[unknown field]"
                          : fieldInfo.name,
                      value: data.customFieldValues[id] || "",
                      type: "text",
                      classes: ["pa-2", "xs12", "md6"],
                      _customFieldID: id,
                    });
                  }
                }
              });
            }

            break;
          }
        }
      }

      console.log("opening edit with", this.fields);

      this.showDialog = true;
    },
    async remove(id) {
      await this.testsRef.doc(id).delete();
      await this.updateTests();
    },
    pushTest(test) {
      const data = test.data();
      this.tests.push({
        id: test.id,
        pool: data.pool,
        timestamp: new Date(data.timestamp),
        borate: data.borate,
        ch: data.ch,
        cya: data.cya,
        fc: data.fc,
        ph: data.ph,
        salt: data.salt,
        ta: data.ta,
      });
    },
    async save() {
      const data = {
        borate: this.fields[0].value,
        ch: this.fields[1].value,
        cya: this.fields[2].value,
        fc: this.fields[3].value,
        ph: this.fields[4].value,
        salt: this.fields[5].value,
        ta: this.fields[6].value,
        customFieldValues: {},
      };

      for (let i = 7; i < this.fields.length; i++) {
        const entry = this.fields[i];
        if (entry.value !== "") {
          const fieldInfo = this.customFields.find(
            (x) => x.id === entry._customFieldID
          );

          if (fieldInfo) {
            data.customFieldValues[entry._customFieldID] =
              fieldInfo.type === "number" ? Number(entry.value) : entry.value;
          }
        }
      }

      await this.testsRef.doc(this.editID).update(data);
      await this.updateTests();
      this.fields.forEach((field) => (field.value = ""));
      this.showDialog = false;
    },
    async updateTests() {
      this.tests = [];
      const tests = await this.testsRef.get();
      tests.forEach((test) => this.pushTest(test));
      this.tests.sort((a, b) => {
        return b.timestamp - a.timestamp;
      });
    },
  },
  async mounted() {
    await Promise.all([
      this.updateTests(),
      this.initSettings(),
      this.initFields(),
    ]);
  },
};
</script>
